export enum HttpCodeEnum {
    See_Other = 303,
    Bad_Request = 400,
    Forbidden = 403,
    Not_Found = 404,
    Not_Acceptable = 406,
    gone= 410,
    Unauthorized = 401,
    Length_Required = 411,
    Precondition_Failed = 412,
    Expectation_Failed = 417,
    Unprocessable_Content = 422,
    Too_Many_Requests = 429

}

export enum RoleValueEnum {
    OESS_Administrator = 1,
    IFMA_Administrator = 2,
    Cohort = 3,
    Organazation_User = 4,
    Individual_User = 5,
    Division_Head = 6
}